import settingshelpers from '~/lib/settingshelpers'

export default {
  mixins: [settingshelpers],
  computed: {
    componentTypes () {
      const types = [{
        type: 'ButtonMap',
        name: this._('Button map')
      },
      {
        type: 'CategoryList',
        name: this._('Category list')
      },
      {
        type: 'Dashboard',
        name: this._('Dashboard')
      },
      {
        type: 'ProductList',
        name: this._('Product list')
      },
      {
        type: 'PricingList',
        name: this._('Pricing list')
      },
      {
        type: 'MovieList',
        name: this._('Movie list')
      },
      {
        type: 'TicketActivityList',
        name: this._('Ticket activities')
      },
      {
        type: 'Receipt',
        name: this._('Receipt')
      },
      {
        type: 'ClientReceipt',
        name: this._('Client Receipt')
      },
      {
        type: 'TransactionList',
        name: this._('Transactions list')
      },
      {
        type: 'OpenList',
        name: this._('Open orders')
      },
      {
        type: 'OpenTicketList',
        name: this._('Ticket reservations')
      },
      {
        type: 'ReportList',
        name: this._('POS Reports')
      },
      {
        type: 'GasPump',
        name: this._('Gas Pump')
      },
      {
        type: 'Workflow',
        name: this._('Workflow')
      },
      {
        type: 'IFrame',
        name: this._('Iframe')
      },
      {
        type: 'CreateReport',
        name: this._('Create report')
      },
      {
        type: 'ScheduledReportList',
        name: this._('Scheduled reports')
      },
      {
        type: 'ArchivedReportList',
        name: this._('Archived reports')
      },
      {
        type: 'Showtimes',
        name: this._('Showtimes')
      },
      {
        type: 'ProductReservationSchedule',
        name: this._('Product reservations')
      },
      {
        type: 'ResourceReservationSchedule',
        name: this._('Resource reservations')
      },
      {
        type: 'ReservationList',
        name: this._('Reservations')
      },
      {
        type: 'BillingCustomerList',
        name: this._('Billing Customers')
      },
      {
        type: 'CustomerList',
        name: this._('Customers')
      },
      {
        type: 'Importer',
        name: this._('Importer')
      },
      {
        type: 'RouteEditor',
        name: this._('Route editor')
      },
      {
        type: 'CategoryProductList',
        name: this._('Category and product list')
      },
      {
        type: 'ContentList',
        name: this._('Content list')
      },
      {
        type: 'ResourceList',
        name: this._('Resource list')
      },
      {
        type: 'NotificationSchedule',
        name: this._('Notification schedule')
      },
      {
        type: 'DiscountList',
        name: this._('Discount codes')
      },
      {
        type: 'OrderList',
        name: this._('Orders')
      },
      {
        type: 'ConsolidatedOrderList',
        name: this._('Shared orders')
      },
      {
        type: 'InvoiceList',
        name: this._('Transactions')
      },
      {
        type: 'SettingsMenu',
        name: this._('Settings')
      },
      {
        type: 'Settings',
        name: this._('General settings')
      },
      {
        type: 'CommunicationSettings',
        name: this._('Communication')
      },
      {
        type: 'StorefrontSettings',
        name: this._('Storefront settings')
      },
      {
        type: 'CollectionSettings',
        name: this._('Collections')
      },
      {
        type: 'CollectionDetails',
        name: this._('Collection')
      },
      {
        type: 'GroupDetails',
        name: this._('Group')
      },
      {
        type: 'CollectionUserDetails',
        name: this._('User')
      },
      {
        type: 'PosSettings',
        name: this._('Johku App')
      },
      {
        type: 'AccountingSettings',
        name: this._('Accounting settings')
      },
      {
        type: 'CompanyProfile',
        name: this._('Company profile')
      },
      {
        type: 'Agenda',
        name: this._('Agenda')
      },
      {
        type: 'SalesChannelSettings',
        name: this._('Sales Channels')
      },
      {
        type: 'TemplateList',
        name: this._('Templates')
      },
      {
        type: 'CodeChecker',
        name: this._('Code checker')
      },
      {
        type: 'TicketReader',
        name: this._('Ticket reader')
      },
      {
        type: 'MaccsboxResults',
        name: this._('Maccsbox results')
      },
      {
        type: 'ScheduledTaskList',
        name: this._('Scheduled tasks')
      },
      {
        type: 'StockScanner',
        name: this._('Stock scanner')
      }]
      if (this.isFeatureEnabled('delivery2.0')) {
        types.push({
          type: 'DeliverySettings',
          name: this._('Delivery settings')
        })
      }
      if (this.isFeatureEnabled('paymentplans')) {
        types.push({
          type: 'SubscriptionList',
          name: this._('Subscriptions')
        })
      }
      if (this.isFeatureEnabled('auditlog')) {
        types.push({
          type: 'AuditLog',
          name: this._('Audit log')
        })
      }
      types.push({
        type: 'AnonymizationSettings',
        name: this._('Anonymization')
      })
      if (this.isFeatureEnabled('max')) {
        types.push({
          type: 'MaxArtifactList',
          name: this._('Johku Max')
        })
        types.push({
          type: 'MaxSpecList',
          name: this._('Reports, dashboards and tools')
        })
        types.push({
          type: 'MaxDashboard',
          name: this._('Johku Max dashboard')
        })
        types.push({
          type: 'MaxTool',
          name: this._('Johku Max tool')
        })
      }
      if (this.isFeatureEnabled('yalelocks')) {
        types.push({
          type: 'YaleLockList',
          name: this._('Yale locks')
        })
      }
      if (this.isFeatureEnabled('partnerapi')) {
        types.push({
          type: 'PartnerIntegrationsSettings',
          name: this._('Partner integrations')
        })
      }
      if (this.isFeatureEnabled('smartdevices')) {
        types.push({
          type: 'SmartDeviceSettings',
          name: this._('Smart Device Settings')
        })
      }
      if (this.isFeatureEnabled('uifeatures')) {
        types.push({
          type: 'UiFeatureCatalog',
          name: this._('Ready-made screens')
        })
      }
      if (this.isFeatureEnabled('johkuadmin')) {
        types.push({
          type: 'Admin',
          name: this._('Johku Admin')
        })
        types.push({
          type: 'AdminCampaigns',
          name: this._('Campaigns')
        })
        types.push({
          type: 'AdminUserAccess',
          name: this._('User access')
        })
        types.push({
          type: 'AdminCampaignDetails',
          name: this._('Campaign')
        })
        types.push({
          type: 'AdminPartners',
          name: this._('Partners')
        })
        types.push({
          type: 'AdminPartnerDetails',
          name: this._('Partner')
        })
        types.push({
          type: 'AdminPartnerIntegrationDetails',
          name: this._('Integration')
        })
        types.push({
          type: 'AdminPartnerApi',
          name: this._('Partner API')
        })
      }
      return types
    }
  },
  methods: {
    getComponentName(type) {
      const ct = this.componentTypes.find(ct => ct.type === type)
      return ct && ct.name ? ct.name : ''
    }
  }
}

